"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const dist_1 = require("../../../fs/dist");
exports.toolDef = {
    name: 'loom_set_context_prefs',
    description: 'Persist sidebar CONTEXT overrides for a target doc to .loom/context-prefs.json. Replace semantics: a provided include/exclude array replaces that stored list (an omitted list is preserved). reset:true clears all overrides for the target (back to auto). Returns the updated entry.',
    inputSchema: {
        type: 'object',
        properties: {
            doc_ulid: { type: 'string', description: 'Target document ULID the overrides apply to' },
            include: {
                type: 'array',
                items: { type: 'string' },
                description: 'Doc ids to force-include (replaces the stored include list)',
            },
            exclude: {
                type: 'array',
                items: { type: 'string' },
                description: 'Doc ids to force-exclude (replaces the stored exclude list)',
            },
            reset: { type: 'boolean', description: 'If true, remove all overrides for this target' },
        },
        required: ['doc_ulid'],
    },
};
async function handle(root, args) {
    const docUlid = args['doc_ulid'];
    if (!docUlid)
        throw new Error('doc_ulid is required');
    const include = Array.isArray(args['include']) ? args['include'] : undefined;
    const exclude = Array.isArray(args['exclude']) ? args['exclude'] : undefined;
    const reset = args['reset'] === true;
    const prefs = await (0, dist_1.setContextPrefs)(root, docUlid, { include, exclude, reset });
    const entry = prefs[docUlid] ?? { include: [], exclude: [] };
    return { content: [{ type: 'text', text: JSON.stringify({ docUlid, entry }) }] };
}
